import React, { useEffect, useRef, useState } from "react";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";

function PinPointMap(props) {
  const { deliveryLocation, dispatch } = props;

  const [draggable, setDraggable] = useState(true);
  const [markerPosition, setMarkerPosition] = useState([27.7213, 85.3575]);

  useEffect(() => {
    setMarkerPosition([deliveryLocation.lat, deliveryLocation.long]);
  }, [deliveryLocation]);

  const toggleDraggable = () => {
    draggable ? setDraggable(true) : setDraggable(false);
  };
  const refmarker = useRef();

  const updatePosition = () => {
    const marker = refmarker.current;
    if (marker != null) {
      const object = marker.leafletElement.getLatLng();
      setMarkerPosition([object.lat, object.lng]);
    }
  };
  return (
    <div>
      <div className="row no-gutters">
        <div className="col-12 col-md-4 col-lg-4">
          <i
            style={{ fontSize: "12px" }}
            className="text-danger font-weight-bolder"
          >
            Mark your Address if possible we will call you for verification
          </i>
        </div>
      </div>
      <div className="row no-gutters">
        <Map
          onClick={(e) => {
            const latlng = e.latlng;
            setMarkerPosition([latlng.lat, latlng.lng]);
            dispatch({ type: "geo", payload: `${latlng.lat},${latlng.lng}` });
          }}
          center={markerPosition}
          zoom={18}
          style={{ height: "300px", width: "450px" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          />
          <Marker
            draggable={false}
            onDragend={updatePosition}
            position={markerPosition}
            ref={refmarker}
          >
            {/* <Popup minWidth={90}>
              <span onClick={toggleDraggable}>
                {draggable ? "DRAG MARKER" : "MARKER FIXED"}
              </span>
            </Popup> */}
          </Marker>
        </Map>
      </div>
    </div>
  );
}

export default PinPointMap;
